
<div 
    class="background-overlay"
    [ngClass]="{'background-overlay--active': show}"
    (click)="clickedOutsideBottomSheet($event)"
>

    <div [id]="sheetID" class="sheet" [@bottomSheetAnimation]="show ? 'open' : 'closed'">

        <div 
            class="sheet-header"
            [ngClass]="{'d-flex justify-content-between': !hideCloseButton}"
        >
            {{title}}

            @if (!hideCloseButton) {
                <mat-icon svgIcon="close" (click)="handleClose()"></mat-icon>
            }
        </div>

        <div class="sheet-content">
            <ng-content></ng-content>
        </div>

    </div>

</div>